import { IHRSettings } from 'legacy/lut/classes/helpers/partner360/HistoricalResultsHelper'

import { IPartnerFlag } from '../../models/IPartnerFlag'

export interface IExpandedByFlags {
  settings: string
  flagsState: IPartnerFlag[]
}

export const getIsExpandedByFlags = ({ settings, flagsState }: IExpandedByFlags): boolean => {
  let isExpandedByFlags = false

  let catSettings: IHRSettings = {}
  try {
    catSettings = JSON.parse(settings)
  } catch {}

  if (catSettings && catSettings.ExpandedByFlags && catSettings.ExpandedByFlags.length) {
    const isExistActiveFlags = flagsState.some(
      (el) => el.isEnabled && catSettings.ExpandedByFlags?.some((flag) => flag === el.name)
    )

    if (isExistActiveFlags) {
      isExpandedByFlags = true
    }
  }

  return isExpandedByFlags
}
